import {
  Button,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
  VStack,
  Box,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import baseUrl from "../vars";
import { useStores } from "../store/store_context";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { authFetch } from "../auth/auth";

const ModalEditRole = observer(({ obj = {} }) => {
  const toast = useToast();
  const { pageStore } = useStores();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const addPermissionToRole = async (perm_id) => {
    const response = await authFetch(
      `${baseUrl}/api/role/permissions?role_id=${obj?.id}&permission_id=${perm_id}`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
            "X-Database": "main"
        },
      }
    );
    if (response.ok) {
      toast({
        description: "Разрешение добавлено",
        duration: "2000",
      });
    }
    await pageStore.getAllRoles();
  };

  const deletePermissionToRole = async (perm_id) => {
    const response = await authFetch(
      `${baseUrl}/api/role/permissions?role_id=${obj?.id}&permission_id=${perm_id}`,
      {
        method: "DELETE",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
        },
      }
    );
    if (response.ok) {
      toast({
        description: "Разрешение удалено",
        duration: "2000",
      });
    }
    await pageStore.getAllRoles();
  };

  const permissionCategories = {
    admin: {
      title: "Административные права",
      permissions: [
        "add permissions",
        "delete permissions",
        "edit roles",
        "edit users",
        "add profits",
        "export excel",
        "get logs",
        "get staff",
      ]
    },
    department: {
      title: "Права департаментов",
      permissions: [
        "get departaments",
        "get workers",
        "set fired",
        "get orders in departament",
        "get pays in departament",
        "get potential in departament",
        "get profits in departament",
        "get reports in departament",
        "get open rev in departament",
        "get open profit in departament",
        "get mops in departament",
        "get pdz in departament",
        "get order_suppliers in departament",
        "get overdue in departament"
      ]
    },
    general: {
      title: "Общие права",
      permissions: [
        "get orders all",
        "get pays all",
        "get potential all",
        "get profits all",
        "get reports all",
        "get open rev all",
        "get open profit all",
        "get mops all",
        "get pdz all",
        "get order_suppliers all",
        "get overdue all"
      ]
    },
    self: {
      title: "Собственные права",
      permissions: [
        "get orders self",
        "get pays self",
        "get potential self",
        "get profits self",
        "get reports self",
        "get open rev self",
        "get open profit self",
        "get mops self",
        "get pdz self",
        "get order_suppliers self",
        "get overdue self"
      ]
    }
  };

  const PERMISSION_TRANSLATIONS = {
    "add permissions": "Добавление прав",
    "add profits": "Добавление отчётов о прибыли",
    "delete permissions": "Удаление прав",
    "edit roles": "Редактирование роли",
    "edit users": "Редактирование пользователя",
    "get departaments": "Получение отделов",
    "get orders all": "Получение всех счетов",
    "get orders in departament": "Получение счетов в отделе",
    "get orders self": "Получение своих счетов",
    "get pays all": "Получение всех оплат",
    "get pays in departament": "Получение оплат в отделе",
    "get pays self": "Получение своих оплат",
    "get potential all": "Получение всех потенциалов",
    "get potential in departament": "Получение потенциалов в департаменте",
    "get potential self": "Получение своих потенциалов",
    "get profits all": "Получение всей прибыли",
    "get profits in departament": "Получение прибыли в департаменте",
    "get profits self": "Получение своей прибыли",
    "get reports all": "Получение всех отчётов",
    "get reports in departament": "Получение отчётов в департаменте",
    "get reports self": "Получение своих отчётов",
    "get workers": "Получение сотрудников",
    "set fired": "Отмечать уволенными",
    "export excel": "Экспорт в эксель",
    "get logs": "получать логи",
    "get open rev all": "Получение всей открытой выручки",
    "get open rev self": "Получение своей открытой выручки",
    "get open rev in departament": "Получение открытой выручки в департаменте",
    "get open profit all": "Получение всей открытой прибыли",
    "get open profit self": "Получение своей открытой прибыли",
    "get open profit in departament": "Получение открытой прибыли в департаменте",
    "get staff": "Получение отчета Сотрудники",
    "get mops all": "Вся Панель МОПов",
    "get mops in departament": "Панель МОПов за департамент",
    "get mops self": "Панель МОПов за себя",
    "get pdz all": "Получение всех карточек счетов",
    "get pdz in departament": "Получение карточек счетов в департаменте",
    "get pdz self": "Получение своих карточек счетов",
    "get order_suppliers all": "Получение всех заказов поставщикам",
    "get order_suppliers in departament": "Получение заказов поставщикам в департаменте",
    "get order_suppliers self": "Получение своих заказов поставщикам",
    "get overdue all": "Получение всей просроченной ДЗ",
    "get overdue in departament": "Получение просроченной ДЗ в департаменте",
    "get overdue self": "Получение своей просроченной ДЗ"
  };

  return (
    <>
      <Button onClick={onOpen}>Изменить</Button>
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent padding={"20px"} bg={"#121212"}>
          <ModalCloseButton color={"white"} />

          <Text
            color={"white"}
            fontWeight={"600"}
            fontSize={"20px"}
            width={"100%"}
            textAlign={"center"}
          >
            Редактирование роли
          </Text>

          <Text color={"white"} fontWeight={"500"} fontSize={"16px"} mt={4}>
            Роль: {obj?.name}
          </Text>

          <VStack
            width={"100%"}
            align={"flex-start"}
            gap={"10px"}
            marginTop={"10px"}
          >
            {Object.entries(permissionCategories).map(([key, category]) => (
              <Box key={key} width="100%">
                <Text 
                  color="white" 
                  fontWeight="bold" 
                  mt={4} 
                  mb={2}
                  fontSize="18px"
                >
                  {category.title}
                </Text>
                
                {pageStore?.permissions
                  ?.filter(perm => category.permissions.includes(perm.name))
                  .map((item, index) => {
                    const hasPermission = obj?.permissions?.some(
                      (perm) => perm.id === item.id
                    );
                    
                    return (
                      <HStack
                        key={index}
                        cursor={"pointer"}
                        color={"white"}
                        fontSize={"16px"}
                        onClick={async () =>
                          hasPermission
                            ? await deletePermissionToRole(item?.id)
                            : await addPermissionToRole(item?.id)
                        }
                        pl={2}
                        py={1}
                        _hover={{ bg: "rgba(255,255,255,0.1)" }}
                        borderRadius="md"
                      >
                        {hasPermission ? (
                          <MdCheckBox size={"20px"} />
                        ) : (
                          <MdCheckBoxOutlineBlank size={"20px"} />
                        )}
                        <Text fontSize={"16px"}>
                          {PERMISSION_TRANSLATIONS[item.name] || item.name}
                        </Text>
                      </HStack>
                    );
                  })
                }
              </Box>
            ))}
          </VStack>
        </ModalContent>
      </Modal>
    </>
  );
});

export default ModalEditRole;
